document.addEventListener("DOMContentLoaded", function () {
	if (document.location.href.indexOf('wp-admin') === -1){ 
		let header = document.getElementById('nav');

		let headerLock = false;
		let headerHeight = header.offsetHeight + 300;
		let currentPos = 0;
		let previousPos = 0;

		window.addEventListener('scroll', function() {

			//get current scroll position
			currentPos = window.pageYOffset;

			if (currentPos < header.offsetHeight) {
				//add hider class
				header.classList.add('nav-hide');

				setTimeout(function() {
					//remove hide and revealed class
					header.classList.remove('nav-hide');
					header.classList.remove('nav-revealed');

					//remove header lock
					headerLock = false;
				}, 100);
			}
			//when these conditions are true, the header can be revealed and if the scroll is in the range but is going back up
			if(!headerLock && currentPos > headerHeight && (previousPos > currentPos)) {

				//enable the header lock
				headerLock = currentPos;

				//add sticky nav class
				header.classList.add('nav-revealed');

			} else if(headerLock && previousPos > currentPos && currentPos > headerHeight) {

				//update header lock
				headerLock = currentPos;
			} else if(headerLock && currentPos > (headerLock + (headerHeight / 2))) {

				//add hider class
				header.classList.add('nav-hide');

				setTimeout(function() {
					//remove hide and revealed class
					header.classList.remove('nav-hide');
					header.classList.remove('nav-revealed');

					//remove header lock
					headerLock = false;
				}, 300);
			}

			//if this is a page that has the blurred hero variant
			if(this.document.body.classList.contains('nav-hero-overlap')) {

				let hero = document.querySelector('div[id^="block-hero-large-"]');

				if(hero) {

					if(currentPos > (hero.offsetHeight - header.offsetHeight)) {
						header.classList.add('nav-default');
					} else {
						header.classList.remove('nav-default');
					}

				}
			}

			//update previous position
			previousPos = currentPos;
		});
	}
});